var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tabList.length > 0 ? _c("div", {
    staticClass: "tabs"
  }, [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey,
      tabBarStyle: {
        fontFamily: "AlibabaPuHuiTiM"
      }
    },
    on: {
      change: _vm.handleTabChange
    }
  }, _vm._l(_vm.tabList, function (item) {
    return _c("a-tab-pane", {
      key: item.flag,
      attrs: {
        tab: item.desc,
        disabled: _vm.disabled
      }
    }, [_c("news-article", {
      attrs: {
        articleList: _vm.articleList,
        total: _vm.total,
        loading: _vm.loading
      },
      on: {
        pageChange: _vm.handlePageChange,
        sizeChange: _vm.handleSizeChange
      }
    })], 1);
  }), 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };